export default "__VITE_ASSET__DJpeDGkQ__"